module.exports = {
  title: '设置报价销售区域',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'offer-sales-form',
    },
  },
};
